import axios from "axios";
import {useEffect, useState} from "react";
import {useParams} from 'react-router-dom';
import Swal from 'sweetalert2';
import {baseUrl, ipAddress, userLocation, userName} from '../Univ.js'
function EditMinCat() {
    const [minData, setminData] = useState({
        "cat": '',
        "addedby": '',
        "ip_add": '',
    });
    const {cat_id} = useParams();
    useEffect(() => {
        try {
            axios.get(baseUrl + 'edit-minor-cat/' + cat_id)
                .then(function (response) {
                    setminData({
                        cat: response.data.cat,
                    });
                });
        } catch (error) {
            console.log(error);
        }
    }, []);
    const handleChange = (event) => {
        setminData({
            ...minData,
            [event.target.name]: event.target.value
        });
    }
    const formSubmit = () => {
        const _formData = new FormData();
        _formData.append('cat', minData.cat);
        _formData.append('addedby', userName);
        _formData.append('ip_add', ipAddress);
        _formData.append('location', userLocation);
        try {
            axios.put(baseUrl + 'edit-minor-cat/' + cat_id, _formData, {
                headers: {
                    'content-type': 'multiple/form-data'
                }
            })
                .then(function (response) {
                    if (response.status == 200) {
                        Swal.fire({
                            title: 'Data has been updated',
                            icon: 'success',
                            timer: 2000,
                            showConfirmButton: false
                        });
                    }
                    setTimeout(() => {
                        window.location.href = ('/add-minor-cat/');
                    }, 2000);
                });
        } catch (error) {
            console.log(error);
        }
    };
    return (
        <section className="container mt-4">
            <div className="row">
                <div className='col-md-9 col-12 mb-2'>
                    <div className='card'>
                        <h4 className='card-header'>Edit cat</h4>
                        <div className='card-body'>
                            <form>
                                <div className="mb-3">
                                    <label htmlFor="title" className="form-label">Edit Category</label>
                                    <input type="text" className="form-control" name="cat" value={minData.cat}
                                           onChange={handleChange} id="cat"/>
                                </div>

                                <button type="button" onClick={formSubmit} className="btn btn-primary">Submit</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
export default EditMinCat;